import React from 'react';
import logo from '../../Assets/Images/logo-mapfre.jpg';
import ods from '../../Assets/Images/planeta-ods.jpg';
import './index.scss';

const Header = () => {
  return (
    <header className='header'>
      <img className='ods' src={ods} alt='' />
      <div className='title'>Concurso de Historias Gráficas Planeta ODS</div>
      <img className='logo' src={logo} alt='' />
    </header>
  );
};

export default Header;
